import React from 'react';
import useElementHeight from '../../hooks/useElementHeight.js';

/** Distância entre o rodapé do cabeçalho fixo e o início do conteúdo (px). */
const CONTENT_GAP = 8;
/** Espelha $app-content-padding-y de _variables.scss. */
const APP_CONTENT_PADDING_Y = 20;

/**
 * Cabeçalho fixo de página (título + ações opcionais) que empurra o conteúdo
 * para baixo conforme a própria altura, medida via useElementHeight.
 *
 * @param {object} props
 * @param {React.ReactNode} props.title      Título exibido no <h1>.
 * @param {React.ReactNode} [props.actions]  Botões/campos alinhados à direita.
 * @param {string} [props.className]         Classes extras do div fixo (ex.: screen-content).
 * @param {string} [props.rowClassName]      Classes extras do .row de conteúdo.
 * @param {React.ReactNode} props.children   Colunas (.col*) do conteúdo.
 */

export default function PageHeaderFixed({ title, actions, children, className, rowClassName }) {
	const [headerRef, headerHeight] = useElementHeight();

	return (
		<>
			<div ref={headerRef} className={'page-header-fixed ' + (className || '')}>
				<h1 className="page-header-fixed-title d-flex flex-column fs-18px">{title}</h1>
				{actions &&
					<div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2">
						{actions}
					</div>
				}
			</div>
			<div className={'row page-header-fixed-row ' + (rowClassName || '')} style={{ marginTop: headerHeight - APP_CONTENT_PADDING_Y + CONTENT_GAP }}>
				{children}
			</div>
		</>
	);
}